import React from 'react';
import ReactDOM from 'react-dom';
import get from '../../../helpers/data_layer/get';
import { fetchData } from '../../../helpers/base_data_fetcher';
import ContactApp from '../../../apps/contact/Index';
import ErrorBoundary from '../../../components/ErrorBoundary';
import dataFetcher from '../../../apps/commerce/helpers/data_fetcher';
import dataFilter from '../../../apps/commerce/helpers/data_filter';
import { getStripeUrls } from '../../../apps/commerce/helpers/stripe_urls';
import facebookLogin from '../../../services/facebookLogin/index';
import updateNewestProfile from '../../../components/tracking/updateNewestProfile';
import '../../../../sass/base.scss';
import '../../../../sass/components/header/base_header.scss';
import '../../../../sass/components/message_box.scss';
import '../../../../sass/apps/contact/index.scss';
import '../../../../sass/pages/listing/contact_message.scss';
import '../../../../sass/pages/listing/mobile/page_tabs.scss';
import trackingSendMessage from './tracking';
import renderMessagingProfile from './messaging_profile_form';
import test_products from '../../../apps/commerce/products/product_selector/test_products';

if (typeof module !== 'undefined') {
  if (module && module.hot) {
    module.hot.accept();
  }
}

const profileFormMount = document.getElementById('profileForm');
if (profileFormMount) {
  renderMessagingProfile(true);
}

const mountElement = document.querySelector('#contact_advertiser_app');
const acceptedPaymentProviders = ['stripe', 'paypal_rest'];

let filteredData = null;
let stripeUrls = null;
let storedPageData = null;
const hideFlashMessaging = false;

const { contactedThreadUrl } = mountElement.dataset;

const initialiseApp = (
  data,
  pageData,
  facebookAppLocale,
  features,
  experiments,
  localisations,
) => {
  if (window.localStorage) {
    const term = JSON.parse(window.localStorage.getItem('last_search_term'));
    if (term) {
      _sr.page.search_term = term.term;
    }
  }

  if (!filteredData) {
    filteredData = dataFilter(...data, pageData, acceptedPaymentProviders);
    const { staticData, context, checkoutCart } = filteredData;
    stripeUrls = getStripeUrls(
      staticData.site,
      context.context,
      checkoutCart.advert_id,
      checkoutCart.stripe_return_paths,
      pageData,
    );
    storedPageData = pageData;
  }

  if (
    window.dataLayer &&
    filteredData.staticData.customer.id &&
    pageData.upgrade_required
  ) {
    if (experiments.success_guarantee_experiment_mobile) {
      filteredData.products = test_products;
    } else {
      filteredData.products = filteredData.products.splice(0, 3).reverse();
    }
  }

  const userLanguage = get('session.language');
  ReactDOM.render(
    <ErrorBoundary message={storedPageData.localisations}>
      <ContactApp
        staticData={filteredData.staticData}
        products={filteredData.products}
        paymentProviders={filteredData.paymentProviders}
        discounts={filteredData.discounts}
        checkoutCart={filteredData.checkoutCart}
        context={filteredData.context}
        stripeUrls={stripeUrls}
        pageData={storedPageData}
        facebookAppLocale={facebookAppLocale}
        userLanguage={userLanguage}
        hideFlashMessaging={hideFlashMessaging}
        winterSale={features.winter_sale}
        facebookLoginActive={features.facebook_login_active}
        experiments={experiments}
        localisations={localisations}
        pageLocalisations={storedPageData.localisations}
        siteId={filteredData.staticData.site.id}
        subDirectory={filteredData.staticData.site.sub_dir}
        walletButtons={features.apple_google_pay}
        contactedThreadUrl={contactedThreadUrl}
      />
    </ErrorBoundary>,
    mountElement,
  );
};

if (mountElement) {
  Promise.all([
    dataFetcher.getAllStaticData(),
    dataFetcher.getAllProducts(),
    dataFetcher.getAllProviders(),
    dataFetcher.getDiscounts(),
    dataFetcher.getCart(),
    dataFetcher.getContext(),
    dataFetcher.getPage(),
    fetchData('config.facebook.app_locale'),
    fetchData('config.features'),
    dataFetcher.getLocalisations(),
  ]).then(
    ([
      staticData,
      products,
      paymentProviders,
      discounts,
      cart,
      context,
      pageData,
      facebookAppLocale,
      features,
      localisations,
    ]) => {
      initialiseApp(
        [staticData, products, paymentProviders, discounts, cart, context],
        pageData,
        facebookAppLocale,
        features,
        {
          // experiments go here if there are any e.g.
          // inline_payment: true,
          success_guarantee_experiment_mobile:
            staticData.site.country == 'GB' &&
            pageData.advert.type == 'offered',
        },
        localisations,
      );
      trackingSendMessage();
      const userType =
        pageData.advert.type == 'offered' ? 'lookingforashare' : 'haveashare';

      const appLocale = get('config.facebook.app_locale');
      facebookLogin.initialiseApp({ language: appLocale });

      const facebookButtons = document.querySelectorAll(
        '[data-facebook-connect]',
      );
      facebookButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          facebookLogin.login(
            {
              usertype_new: userType,
              custom_password_required: 0,
              location: pageData.search.location_id,
              loginfrom_url: pageData.loginReturnPath,
              referred_by: staticData.affiliate.id,
            },
            staticData.site.sub_dir,
          );
        });
      });
    },
  );
}
trackingSendMessage();
if (get('session.loggedin')) {
  updateNewestProfile();
}
